var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9231 1.70829C12.6247 1.70829 12.3385 1.82467 12.1275 2.03183L1.99158 11.9826L1.46116 14.0655L3.58283 13.5448L13.7187 3.59402C13.8232 3.49144 13.9061 3.36967 13.9626 3.23565C14.0192 3.10163 14.0483 2.95799 14.0483 2.81292C14.0483 2.66786 14.0192 2.52422 13.9626 2.3902C13.9061 2.25618 13.8232 2.1344 13.7187 2.03183C13.6142 1.92925 13.4902 1.84789 13.3537 1.79237C13.2172 1.73686 13.0708 1.70829 12.9231 1.70829ZM11.2572 1.17744C11.699 0.743682 12.2982 0.5 12.9231 0.5C13.2325 0.5 13.5388 0.559826 13.8247 0.676061C14.1105 0.792296 14.3702 0.962665 14.589 1.17744C14.8078 1.39221 14.9813 1.64719 15.0997 1.92781C15.2181 2.20842 15.279 2.50919 15.279 2.81292C15.279 3.11666 15.2181 3.41742 15.0997 3.69804C14.9813 3.97866 14.8078 4.23363 14.589 4.44841L4.33259 14.5175C4.25372 14.5949 4.1549 14.6498 4.0467 14.6764L0.76465 15.4819C0.554942 15.5334 0.333104 15.4731 0.180255 15.323C0.0274056 15.173 -0.03404 14.9552 0.0183869 14.7493L0.838899 11.5272C0.86595 11.421 0.9219 11.3239 1.00077 11.2465L11.2572 1.17744ZM7.38462 14.8959C7.38462 14.5622 7.66014 14.2917 8.00001 14.2917H15.3846C15.7245 14.2917 16 14.5622 16 14.8959C16 15.2295 15.7245 15.5 15.3846 15.5H8.00001C7.66014 15.5 7.38462 15.2295 7.38462 14.8959Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIcon);
export default __webpack_public_path__ + "static/media/sign-icon.9106fd2d1dd96b78722900d6fc27be30.svg";
export { ForwardRef as ReactComponent };